import { render } from "./profit_itemlist.vue?vue&type=template&id=f2f5f7b4&ts=true"
import script from "./profit_itemlist.vue?vue&type=script&lang=ts"
export * from "./profit_itemlist.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__